import { Navigate } from "react-router-dom";
import Auth from "../containers/Auth";
import Login from "../views/Auth";
import Slider from "../views/Sidebar/Slider";
import Project from "../views/Sidebar/Project";
import ProjectCategory from "../views/Sidebar/ProjectCategory";
import Service from "../views/Sidebar/Service";
import OurTeam from "../views/Sidebar/OurTeam";
import Section from "../views/Sidebar/Section";
import Feedback from "../views/Sidebar/Feedback";
import News from "../views/Sidebar/News";
import Vacancy from "../views/Sidebar/Vacancy";
import ContactMessage from "../views/Sidebar/ContactMessage";
import VacancyMessage from "../views/Sidebar/VacancyMessage";
import Forms from "../views/Sidebar/Project/Forms";
import Statistics from "../views/Sidebar/Statistics";
import Blog from "../views/Sidebar/Blog";
import BlogForm from "../views/Sidebar/Blog/Form";
import Customers from "../views/Sidebar/Customer";

export const routes = [
  {
    path: "/slider",
    element: <Slider />,
    // index: true,
    key: 1,
  },
  {
    path: "/blog",
    element: <Blog />,
    key: 221,
  },
  {
    path: "/blog/form",
    element: <BlogForm />,
    key: 120,
  },
  {
    path: "/projects",
    element: <Project />,
    // index: true,
    key: 2,
  },
  {
    path: "/projects/form",
    element: <Forms />,
    key: 10,
  },
  {
    path: "/category",
    element: <ProjectCategory />,
    // index: true,
    key: 21,
  },
  {
    path: "/services",
    element: <Service />,
    // index: true,
    key: 3,
  },
  {
    path: "/ourteam",
    element: <OurTeam />,
    // index: true,
    key: 4,
  },
  {
    path: "/section",
    element: <Section />,
    // index: true,
    key: 5,
  },
  {
    path: "/feedback",
    element: <Feedback />,
    // index: true,
    key: 6,
  },
  {
    path: "/news",
    element: <News />,
    // index: true,
    key: 7,
  },
  {
    path: "/vacancies",
    element: <Vacancy />,
    // index: true,
    key: 8,
  },
  {
    path: "/contact-message",
    element: <ContactMessage />,
    // index: true,
    key: 10,
  },
  {
    path: "/vacancy-message",
    element: <VacancyMessage />,
    // index: true,
    key: 101,
  },
  {
    path: "/stats",
    element: <Statistics />,
    // index: true,
    key: 102,
  },
  {
    path: "/customers",
    element: <Customers />,
    // index: true,
    key: 103,
  },

  { path: "*", element: <Navigate to="/slider" />, key: 21 },
];

export const publicRoutes = [
  {
    element: <Auth />,
    children: [
      { path: "/login", index: true, element: <Login />, key: 22 },
      { path: "*", element: <Navigate to="/login" />, key: 23 },
    ],
  },
];
